import { useContext } from 'react'
import MultiImagesContext from '@contexts/multiImagesContext'

const useIsMultiImagesGallery = (): boolean => useContext(MultiImagesContext)

export default useIsMultiImagesGallery
